var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NonVisualInfo, StepBase, StepLabel, StepList, StepNode } from './subcomponents';
var Stepper = function (_a) {
    var steps = _a.steps, _b = _a.circleRadius, circleRadius = _b === void 0 ? 4 : _b, onClick = _a.onClick, className = _a.className, activeStep = _a.activeStep, element = _a.element, completedIcon = _a.completedIcon, nonVisualInfoCompletedStep = _a.nonVisualInfoCompletedStep, nonVisualInfoCurrentStep = _a.nonVisualInfoCurrentStep, nonVisualInfoUpcomingStep = _a.nonVisualInfoUpcomingStep, props = __rest(_a, ["steps", "circleRadius", "onClick", "className", "activeStep", "element", "completedIcon", "nonVisualInfoCompletedStep", "nonVisualInfoCurrentStep", "nonVisualInfoUpcomingStep"]);
    var getStatus = function (isCompleted, isActive) {
        if (isCompleted) {
            return nonVisualInfoCompletedStep;
        }
        if (isActive) {
            return nonVisualInfoCurrentStep;
        }
        return nonVisualInfoUpcomingStep;
    };
    return (_jsx(StepBase, __assign({}, props, { className: className }, { children: steps.map(function (step, index) {
            var isCompleted = index < activeStep;
            var isActive = index === activeStep;
            var isLastStep = activeStep === steps.length - 1;
            var status = getStatus(isCompleted, isActive);
            var stepLabel = step.label;
            return (_jsxs(StepList, __assign({ "data-testid": "step-list-".concat(stepLabel), circleRadius: circleRadius, isCompleted: isCompleted, isActive: isActive }, { children: [element !== null && element !== void 0 ? element : (_jsx(StepNode, __assign({ circleRadius: circleRadius, "data-testid": "step-node-".concat(stepLabel), isActive: isActive, isCompleted: isCompleted, isLastStep: isLastStep, onClick: onClick &&
                            (function (e) { return onClick(e, index); }) }, { children: (isCompleted || isLastStep) && completedIcon }))), _jsx(NonVisualInfo, { children: status }), _jsx(StepLabel, __assign({ "data-testid": "step-label-".concat(stepLabel), circleRadius: circleRadius, isActive: isActive }, { children: stepLabel }))] }), step.label));
        }) })));
};
export default Stepper;
//# sourceMappingURL=Stepper.js.map